/**
 * CSV Export Utilities
 * Browser-based CSV generation and download using Blob API.
 */

/**
 * Convert a 2D array of rows into a CSV string and trigger a file download.
 * @param {Array<Array<string|number>>} rows - 2D array of cell values
 * @param {string} filename - Download filename (should include .csv extension)
 */
export function downloadCSV(rows, filename) {
  const csvString = rows
    .map(row =>
      row.map(cell => {
        const str = cell == null ? '' : String(cell);
        // Wrap in quotes if contains comma, quote, or newline
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
          return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      }).join(',')
    )
    .join('\n');

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Sanitize a string for use as a filename.
 * @param {string} name
 * @returns {string}
 */
export function sanitizeFilename(name) {
  return (name || 'untitled')
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .substring(0, 50)
    .toLowerCase();
}
